import React, { useContext } from 'react';
import { SessionContext } from 'contexts/SessionContext';
import { AppSumoContext } from 'contexts/AppSumoContext';
import { Link } from 'react-router-dom';
import { HiOutlineExclamationTriangle, HiOutlineSparkles } from 'react-icons/hi2';
import { TbCoins } from 'react-icons/tb';
import { formatNumber } from 'utils/formatNumber';

const VIDEO_CREDIT_WARNING_THRESHOLD = 1499;

const VideoCreditWarning = ({ className = '' }) => {
    const { user } = useContext(SessionContext);
    const { isSumoling, isLicensee } = useContext(AppSumoContext);

    // images_allowed/images_spent describe the monthly plan only; add-on credits are a
    // separate pool. images_total_available is the API's combined figure — summing them
    // here counted the add-on balance twice.
    // null is the API's "unlimited allowance" sentinel, and undefined just means the
    // balance has not loaded yet — neither is something to warn about.
    const remainingCredits = user?.balance?.images_total_available;

    if (remainingCredits == null || remainingCredits >= VIDEO_CREDIT_WARNING_THRESHOLD) return null;

    const showViralShortsRedirect = isSumoling() || isLicensee();
    const isVeryLow = remainingCredits < 500;

    const colors = isVeryLow
        ? { border: 'border-red-200/60 dark:border-red-800/40', bg: 'bg-red-50 dark:bg-red-950/20', accent: 'bg-red-500', icon: 'text-red-500 dark:text-red-400', text: 'text-red-700 dark:text-red-300' }
        : { border: 'border-amber-200/60 dark:border-amber-800/40', bg: 'bg-amber-50/80 dark:bg-amber-950/20', accent: 'bg-amber-500', icon: 'text-amber-500 dark:text-amber-400', text: 'text-amber-700 dark:text-amber-300' };

    return (
        <div className={`relative overflow-hidden rounded-lg border ${colors.border} ${colors.bg} ${className}`}>
            <div className={`absolute top-0 left-0 w-0.5 h-full ${colors.accent}`} />
            <div className="flex items-center gap-2 pl-3 pr-3 py-2">
                <HiOutlineExclamationTriangle className={`w-3.5 h-3.5 shrink-0 ${colors.icon}`} />
                <p className={`text-[11px] leading-snug ${colors.text}`}>
                    {"Video generation costs "}
                    <strong>{"150\u20131,000 credits"}</strong>
                    {" each. "}
                    <span className="font-bold">
                        <TbCoins className="w-3 h-3 inline align-middle" />
                        {" "}{formatNumber(remainingCredits)} left
                    </span>
                    {showViralShortsRedirect && (
                        <div>
                            <Link to="/viral-shorts" className="font-semibold text-emerald-600 dark:text-emerald-400 hover:underline">
                                <HiOutlineSparkles className="w-3 h-3 inline align-middle" />
                                {" "}Try Viral Shorts
                            </Link>
                            {" to save credits"}
                        </div>
                    )}
                </p>
            </div>
        </div>
    );
};

export default VideoCreditWarning;
